<section class="tax-invoice-join">
  <div class="box-container">
    <div class="tax-invoice-topic">
      <!-- desktop and tablet heading -->
      <div
        class="tax-invoice-topic__heading tax-invoice-topic__heading--desktop color-white"
        [innerHtml]="'TAX_INVOICE.SECTION_JOIN.HEADING' | translate"
      >
      </div>
      <!-- mobile heading -->
      <div
        class="tax-invoice-topic__heading tax-invoice-topic__heading--mobile color-white"
        [innerHtml]="'TAX_INVOICE.SECTION_JOIN.HEADING_MOBILE' | translate"
      >
      </div>

      <div class="tax-invoice-topic__detail color-white" [innerHtml]="'TAX_INVOICE.SECTION_JOIN.DETAIL' | translate">
      </div>
    </div>

    <div class="box">
      <div class="box__btn">
        <a
          href="https://auth.flowaccount.com/{{ translate.currentLang }}/Account/Register"
          rel="noopener noreferrer"
          class="flowbtn app-btn box__btn--layout"
          (click)="onSignupEvent()"
        >
          {{ 'TAX_INVOICE.SECTION_JOIN.REGISTER_BUTTON' | translate }}</a
        >
      </div>
    </div>
  </div>
</section>
